"use strict";require('@ebay/skin/badge');